import { CCol, CRow } from '@coreui/react'
import _ from 'lodash'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import BudgetCard from '../BudgetCard/BudgetCard'
import styles from './invoiceBudgetComponent.module.scss'

const InvoiceBudgetComponent = ({ budget }) => {
  const { t } = useTranslation()

  const monthlyBudget = _.get(budget, 'monthly')
  const annualBudget = _.get(budget, 'annual')

  const budgetCardData = [
    { title: t('invoices.monthly'), value: monthlyBudget },
    { title: t('invoices.annually'), value: annualBudget },
  ]

  const renderBudgetCards = () =>
    budgetCardData.map(({ title, value }) => <BudgetCard key={title} title={title} value={value} />)

  return (
    <>
      <h3>{t('invoices.budget')}</h3>
      <div>
        <h4>{t('invoices.accountBudgets')}</h4>
        <div className={styles.subtitleTextStyle}>{t('invoices.budgetEstimateInfo')}</div>
      </div>
      <div className={styles.budgetCards}>{renderBudgetCards()}</div>
    </>
  )
}

InvoiceBudgetComponent.defaultProps = {
  budget: { monthly: 0, annual: 0 },
}

InvoiceBudgetComponent.propTypes = {
  budget: PropTypes.object,
}

export default InvoiceBudgetComponent
